module.exports = __webpack_public_path__ + "static/media/sidenav-icon-orders.c4c56ee2.svg";